import React from 'react';
import PropTypes from 'prop-types';
import {useFormikContext} from 'formik';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import DetailField from './DetailField';
import {find} from 'lodash';

const emojiForImpactFactor = (impactFactors, name) => {
  const impactFactor = find(impactFactors, {name}) || {emoji: ''};
  return impactFactor.emoji;
};

const propTypes = {
  question: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    impactFactors: PropTypes.arrayOf(
      PropTypes.shape({
        emoji: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    ),
  }),
};

const ImpactFactorDetails = ({question}) => {
  const {values} = useFormikContext();

  return (
    <BaseStep stepHeader="Care to elaborate?">
      {values.answers.map(({identifier, questionId}, index) => {
        if (questionId !== question._id) {
          return null;
        }

        return (
          <DetailField
            key={identifier}
            name={identifier}
            emoji={emojiForImpactFactor(question.impactFactors, identifier)}
            index={index}
          />
        );
      })}
    </BaseStep>
  );
};

ImpactFactorDetails.propTypes = propTypes;
export default ImpactFactorDetails;
